import { AfterViewInit, Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NbTabComponent } from '@nebular/theme';

@Directive({
  selector: '[ubsDynamicTab]'
})
export class DynamicTabDirective implements OnChanges, AfterViewInit{
  tabsEl:Element;
  @Input() selectedTab:NbTabComponent;

  constructor(private el:ElementRef<HTMLElement>) { }
  
  ngOnChanges(changes: SimpleChanges): void {
    if(changes["selectedTab"]){
      console.log(this.selectedTab);
    }
  }
  
  ngAfterViewInit(): void {
    this.tabsEl = <HTMLElement>this.el.nativeElement.querySelector('.product-tabs-set');
    if(this.tabsEl != undefined){
      console.log(this.tabsEl);
      //let tabElements = this.tabsEl.nativeElement.getElementsByClassName('product-tabs');
      
    }
  }
  
  onChangeTab(e:NbTabComponent){
    if(this.selectedTab == undefined){
      this.selectedTab = e
    }else{
      if(e.tabId === this.selectedTab.tabId){
        console.log("It's the same ---- Doing Nothing")
      }else{
        console.log("It's NOT the same ---- Doing Somethingf")
        this.selectedTab = e;
        e.active = true;
        /* this.tabsComp.tabs.forEach( ( tab: NbTabComponent, index: number, array: any[] ) => {
          if ( tab.tabId != e.tabId && tab.active === true ) {
            tab.active = false
          }
        }); */
      }
      
    }
    //console.log(e);
    
    
  }



}
